module.exports = __webpack_public_path__ + "assets/img/go_complete.6974a670.png";